import React from 'react';
import './PaymentResult.css';

const PaymentFailure = () => {
  return (
    <div className="payment-result-container failure">
      <div className="payment-result-content">
        <div className="payment-icon failure-icon">✕</div>
        <h1 className="payment-title">PAGO NO PROCESADO</h1>
        <p className="payment-message">
          Hubo un problema al procesar tu pago.
        </p>
        <div className="payment-details">
          <p>Posibles causas:</p>
          <ul>
            <li>Fondos insuficientes</li>
            <li>Tarjeta rechazada</li>
            <li>Datos incorrectos</li>
          </ul>
        </div>
        <div className="payment-actions">
          <a href="#tienda" className="btn-volver-inicio">INTENTAR NUEVAMENTE</a>
          <a href="/" className="btn-seguir-comprando">VOLVER AL INICIO</a>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
